import React, { useState } from "react";

import { auth, googleProvider, githubProvider, twitterAuthProvider, yahooAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword } from '../../services/authentication';
import { signInWithPopup } from 'firebase/auth';
import { Link } from "react-router-dom";
import { redirectInternal, setToken, setToStorage } from "../../services/authService"
import httpService from "../../services/httpService";

import img from "../../assets/images/review/google.png";
import img2 from "../../assets/images/review/tweet.png";

function SignIn() {
  const [showPass, setShowPass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadButton, setLoadButton] = useState(false);
  const [errorMessageEmailAndPass, setErrorMessageEmailAndPass] = useState("");

  const isWithinLastHour = (dbDateTime) => {
    const now = new Date(); // current datetime
    const dbDate = new Date(dbDateTime); // convert DB datetime to Date object

    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000); // 1 hour ago

    return dbDate >= oneHourAgo && dbDate <= now;
  }


  const loginWithGoogle = async () => {
    try {
      setLoader(true);
      const result = await signInWithPopup(auth, googleProvider);

      const user = result.user;
      const { displayName, email, photoURL, uid } = user;
      const savedUser = await httpService.post("auth/signup", {
        username: displayName,
        email,
        avatar: photoURL,
        googleUid: uid,
      });

      if (savedUser.status === 200 || savedUser.status === 201) {
        setToken(savedUser.data.data.accessToken);
        setToStorage('avatar', photoURL);
        setToStorage('username', displayName);
        setToStorage('id', savedUser.data.data.user._id);
        const continueTo = localStorage.getItem("current-page") || "/";
        return redirectInternal(continueTo);
      };
    } catch (error) {
      localStorage.removeItem("showLoader");
      setLoader(false);
      setErrorMessage("Login failed. Please try again.");
      alert("Login failed. Please try again.");
    }
  };

  const loginWithTwitter = async () => {
    try {
      setLoader(true);
      const result = await signInWithPopup(auth, twitterAuthProvider);

      console.log(result, 'result >>>>', "generate for me a log of what this will be in return", "format: table, with column names and values, other things...");

      // const user = result.user;
      // const { displayName, email, photoURL, uid } = user;
      // const savedUser = await httpService.post("auth/signup", {
      //   username: displayName,
      //   email,
      //   avatar: photoURL,
      //   googleUid: uid,
      // });

      // if (savedUser.status === 200 || savedUser.status === 201) {
      //   setToken(savedUser.data.data.accessToken);
      //   setToStorage('avatar', photoURL);
      //   setToStorage('username', displayName);
      //   setToStorage('id', savedUser.data.data.user._id);
      //   const continueTo = localStorage.getItem("current-page") || "/";
      //   return redirectInternal(continueTo);
      // };
    } catch (error) {
      localStorage.removeItem("showLoader");
      setLoader(false);
      setErrorMessage("Login failed. Please try again.");
      alert("Login failed. Please try again.");
    }
  };

  const loginWithYahoo = async () => {
    try {
      setLoader(true);
      const result = await signInWithPopup(auth, yahooAuthProvider);

      console.log(result, 'result >>>>', "generate for me a log of what this will be in return", "format: table, with column names and values, other things...");

      // const user = result.user;
      // const { displayName, email, photoURL, uid } = user;
      // const savedUser = await httpService.post("auth/signup", {
      //   username: displayName,
      //   email,
      //   avatar: photoURL,
      //   googleUid: uid,
      // });

      // if (savedUser.status === 200 || savedUser.status === 201) {
      //   setToken(savedUser.data.data.accessToken);
      //   setToStorage('avatar', photoURL);
      //   setToStorage('username', displayName);
      //   setToStorage('id', savedUser.data.data.user._id);
      //   const continueTo = localStorage.getItem("current-page") || "/";
      //   return redirectInternal(continueTo);
      // };
    } catch (error) {
      localStorage.removeItem("showLoader");
      setLoader(false);
      setErrorMessage("Login failed. Please try again.");
    }
  };

  const logginWithUsernameAndPassword = async (e) => {
    e.preventDefault();
    try {
      setLoadButton(true);
      const savedUserToFirebase = await signInWithEmailAndPassword(auth, email, password);

      const savedUser = await httpService.post("auth/login-with-password", {
        email,
        password
      });

      if (savedUser.status === 200 || savedUser.status === 201) {
        setToken(savedUser.data.data.accessToken);
        setToStorage('avatar', "");
        setToStorage('username', email.split("@")[0]);
        setToStorage('id', savedUser.data.data.user._id);
        const continueTo = localStorage.getItem("current-page") || "/";
        return redirectInternal(continueTo);
      };
    } catch (error) {
      if (error?.code === "auth/email-already-in-use") {
        setErrorMessageEmailAndPass("User already exists. Please login instead.");
        setLoadButton(false);
        return;
      } else if (error?.code) {
        setErrorMessageEmailAndPass(error.code);
        setLoadButton(false);
        return;
      };

      localStorage.removeItem("showLoader");
      setLoadButton(false);
      setErrorMessage("Login failed. Please try again.");
    }
  };


  return (
    <section className="account-section">
      {loader ? (<section className="account-section">
        <div className="tf-container">
          <div className="row">
            <div className="wd-form-login">
              <h4>Loading article...</h4>
            </div>
          </div>
        </div>
      </section>) : (
        <div className="tf-container">
          <div className="row">
            <div className="wd-form-login">
              <h4>Login</h4>
              <form action="/">
                <div className="ip">
                  <label>
                    Email address<span>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    onChange={(e) => { setEmail(e.target.value) }}
                  />
                </div>
                <div className="ip">
                  <label>
                    Password<span>*</span>
                  </label>
                  <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    onChange={(e) => { setPassword(e.target.value) }}
                  />
                </div>
                <p className="text-danger error-message">{errorMessageEmailAndPass}</p>
                {loadButton ? (
                  <div className="group-ant-choice">
                    <button disabled>Loading...</button>
                  </div>
                ) : (
                  <>
                    <div className="group-ant-choice">
                      <button onClick={logginWithUsernameAndPassword}>Login</button>
                    </div>
                    <a href="/register" className="mt-2 text-primary d-block">
                      Don't have an account? Register
                    </a>
                  </>
                )}


                <p className="line-ip">
                  <span>or</span>
                </p>
                <Link to="#" onClick={loginWithGoogle} className="btn-social">
                  <img src={img} alt="images" /> Continue with Google
                </Link>
                <p className="text-danger error-message">{errorMessage}</p>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default SignIn;
